"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EClaimFlowType;
(function (EClaimFlowType) {
    EClaimFlowType["NONE"] = "NONE";
    EClaimFlowType["SINCE_NO_CLAIM"] = "SINCE_NO_CLAIM";
    EClaimFlowType["BY_STATUS"] = "BY_STATUS";
    EClaimFlowType["STILL_PENDING"] = "STILL_PENDING";
    EClaimFlowType["BILL_AMOUNT_AND_NO_CLAIM"] = "BILL_AMOUNT_AND_NO_CLAIM";
    EClaimFlowType["NOT_EQUAL_POSTED_AMOUNT"] = "NOT_EQUAL_POSTED_AMOUNT";
    EClaimFlowType["PAID_IN_AGING"] = "PAID_IN_AGING";
})(EClaimFlowType = exports.EClaimFlowType || (exports.EClaimFlowType = {}));
var EClaimTaskStatus;
(function (EClaimTaskStatus) {
    EClaimTaskStatus["OPENED"] = "OPENED";
    EClaimTaskStatus["COMPLETED"] = "COMPLETED";
    EClaimTaskStatus["INCORRECT"] = "INCORRECT";
})(EClaimTaskStatus = exports.EClaimTaskStatus || (exports.EClaimTaskStatus = {}));
var EClaimStatus;
(function (EClaimStatus) {
    EClaimStatus["NA"] = "NA";
    EClaimStatus["PENDING"] = "PENDING";
    EClaimStatus["DENIED"] = "DENIED";
    EClaimStatus["NO_CLAIM"] = "NO_CLAIM";
    EClaimStatus["PAID"] = "PAID";
    EClaimStatus["ERROR"] = "ERROR";
    EClaimStatus["READY_TO_SEND"] = "READY_TO_SEND";
    EClaimStatus["AWAITING"] = "AWAITING";
    EClaimStatus["NOT_REGISTERED"] = "NOT_REGISTERED";
    EClaimStatus["SENT"] = "SENT";
    EClaimStatus["FIX_LATER"] = "FIX_LATER";
})(EClaimStatus = exports.EClaimStatus || (exports.EClaimStatus = {}));
var EClaimBatchStatus;
(function (EClaimBatchStatus) {
    EClaimBatchStatus["OPENED"] = "OPENED";
    EClaimBatchStatus["IN_PROCESSING"] = "IN_PROCESSING";
    EClaimBatchStatus["INCORRECT"] = "INCORRECT";
    EClaimBatchStatus["COMPLETED"] = "COMPLETED";
})(EClaimBatchStatus = exports.EClaimBatchStatus || (exports.EClaimBatchStatus = {}));
var EClaimHistoryActionType;
(function (EClaimHistoryActionType) {
    EClaimHistoryActionType["CREATED"] = "CREATED";
    EClaimHistoryActionType["SENT"] = "SENT";
    EClaimHistoryActionType["EDITED"] = "EDITED";
    EClaimHistoryActionType["COMPLETED"] = "COMPLETED";
    EClaimHistoryActionType["ACKNOWLEDGMENT_RECEIVED"] = "ACKNOWLEDGMENT_RECEIVED";
    EClaimHistoryActionType["STATUS_CHANGE"] = "STATUS_CHANGE";
    EClaimHistoryActionType["REMITTANCE_RECEIVED"] = "REMITTANCE_RECEIVED";
    EClaimHistoryActionType["RETURNED_WITH_ERRORS"] = "RETURNED_WITH_ERRORS";
})(EClaimHistoryActionType = exports.EClaimHistoryActionType || (exports.EClaimHistoryActionType = {}));
var EClaimFlowStatuses;
(function (EClaimFlowStatuses) {
    EClaimFlowStatuses["NONE"] = "NONE";
    EClaimFlowStatuses["PAID"] = "PAID";
    EClaimFlowStatuses["PENDING"] = "PENDING";
    EClaimFlowStatuses["DECLINED"] = "DECLINED";
})(EClaimFlowStatuses = exports.EClaimFlowStatuses || (exports.EClaimFlowStatuses = {}));
